var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.444,
    height: 26.317,
    viewBox: "0 0 93.444 26.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 93.444,
    height: 26.317,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_20",
    "data-name": "Artwork 20",
    transform: "translate(46.722 13.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-46.722 -13.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M277.216.973A.666.666,0,0,0,276.625,0h-3.9a1.106,1.106,0,0,0-1.079.915h0q-.006.034-.01.069l-.58,4.126a.672.672,0,0,0-.01.115.661.661,0,0,0,.655.661h2.313a1.106,1.106,0,0,0,1-.635Z",
    transform: "translate(-245.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M202,73.022a10.566,10.566,0,0,0-14.435,0,9.705,9.705,0,0,0,0,13.924,10.566,10.566,0,0,0,14.435,0,9.706,9.706,0,0,0,0-13.924m-2.869,8.441a4.215,4.215,0,0,1-1.19,2.9,5.761,5.761,0,0,1-6.315,0,4.209,4.209,0,0,1-1.191-2.9l-.052-1.478.052-1.478a4.238,4.238,0,0,1,1.191-2.883,5.669,5.669,0,0,1,6.315,0,4.244,4.244,0,0,1,1.19,2.883,21.128,21.128,0,0,1,0,2.957",
    transform: "translate(-167.016 -63.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M811.145,84.922a3.236,3.236,0,0,0,.592.425,4.072,4.072,0,0,0,2,.422A4.643,4.643,0,0,0,816,85.32a1.376,1.376,0,0,0,.789-1.24,1.209,1.209,0,0,0-.408-.94,3.616,3.616,0,0,0-1.308-.654q-.9-.286-2.588-.64a11.271,11.271,0,0,1-4.932-1.989,4.641,4.641,0,0,1-1.634-3.814,5.063,5.063,0,0,1,.94-3.011,6.11,6.11,0,0,1,2.67-2.057,10.211,10.211,0,0,1,4.019-.736,9.642,9.642,0,0,1,4.155.831,7.13,7.13,0,0,1,2.7,2.071,4.4,4.4,0,0,1,.995,2.438.6.6,0,0,1-.164.422.531.531,0,0,1-.409.177h-3.2a1.984,1.984,0,0,1-1.278-.226,2.147,2.147,0,0,1-.457-.569,2.392,2.392,0,0,0-1.642-1.006,3.358,3.358,0,0,0-.609-.052h-.089a3.23,3.23,0,0,0-1.771.409,1.34,1.34,0,0,0-.627,1.2,1.372,1.372,0,0,0,.818,1.239,12.346,12.346,0,0,0,3.051.913,17.454,17.454,0,0,1,4.073,1.158,5.139,5.139,0,0,1,2.234,1.8,5.006,5.006,0,0,1,.722,2.793,5.071,5.071,0,0,1-1.062,3.215,6.646,6.646,0,0,1-2.942,2.084,11.953,11.953,0,0,1-4.3.722,11.813,11.813,0,0,1-4.5-.763,6.552,6.552,0,0,1-2.806-2.016,4.705,4.705,0,0,1-1.009-2.724.531.531,0,0,1,.177-.409.6.6,0,0,1,.422-.163h2.7c.328,0,.66-.016.988,0a1.177,1.177,0,0,1,.75.327,2.443,2.443,0,0,1,.3.387,2.6,2.6,0,0,0,.377.426",
    transform: "translate(-728.604 -63.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M415.051,92.063a.625.625,0,0,1-.218-.473V74.052a.678.678,0,0,1,.2-.5.712.712,0,0,1,.524-.2h3.292a1.087,1.087,0,0,1,.991.514l6.875,10.08V74.052a.677.677,0,0,1,.2-.5.712.712,0,0,1,.524-.2h3.7a.716.716,0,0,1,.525.2.68.68,0,0,1,.2.5V91.563a.678.678,0,0,1-.2.5.715.715,0,0,1-.525.2h-3.292a1.084,1.084,0,0,1-.99-.514l-6.847-9.675V91.59a.612.612,0,0,1-.218.486.794.794,0,0,1-.539.189h-3.7a.726.726,0,0,1-.51-.2",
    transform: "translate(-375.265 -66.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M15.856,83.983a4.357,4.357,0,0,0-1.865-1.608A4.439,4.439,0,0,0,15.518,81a3.711,3.711,0,0,0,.689-2.243,4.93,4.93,0,0,0-1.675-4,7.824,7.824,0,0,0-5.108-1.405H.676a.637.637,0,0,0-.487.2.709.709,0,0,0-.189.5V91.59a.647.647,0,0,0,.2.473.648.648,0,0,0,.473.2H9.667a7.785,7.785,0,0,0,5.148-1.513,5.244,5.244,0,0,0,1.8-4.243,4.421,4.421,0,0,0-.757-2.527M5.081,77H8.857a2.109,2.109,0,0,1,1.554.527,1.849,1.849,0,0,1,.527,1.365,1.9,1.9,0,0,1-.541,1.405,2.082,2.082,0,0,1-1.54.541H5.081ZM10.735,88.01a2.156,2.156,0,0,1-1.635.608H5.081V84.375H9.1a2.162,2.162,0,0,1,1.621.608,2.242,2.242,0,0,1,.014,3.027",
    transform: "translate(0 -66.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M634.427,73.551a.682.682,0,0,0-.5-.2h-3.675a.692.692,0,0,0-.7.7v11.1a3.531,3.531,0,0,1-.8,2.5,3.509,3.509,0,0,1-4.567.013,3.518,3.518,0,0,1-.8-2.513v-11.1a.693.693,0,0,0-.7-.7h-3.7a.637.637,0,0,0-.487.2.709.709,0,0,0-.189.5V85.2a6.963,6.963,0,0,0,2.176,5.594,8.943,8.943,0,0,0,6.013,1.865,8.848,8.848,0,0,0,5.972-1.865,6.985,6.985,0,0,0,2.162-5.594V74.052a.68.68,0,0,0-.2-.5",
    transform: "translate(-559.33 -66.353)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4b97561953e3365654de06a27d6e90f.svg";
export { ForwardRef as ReactComponent };